module.exports = __webpack_public_path__ + "static/media/flexline_hd_logo_en.b4bfc9ef.png";